<template>
  <div class="page-wrapper">
    <div :class="['header-wrap style5', { sticky: isSticky }]">
      <MainNavbar />
    </div>
    <MainBanner />
    <OurFeatures />
    <HowWeWork />
    <BestServices />
    <OurDepartment />
    <OurTestimonials />
    <BookAppointment />
    <GalleryExhibition />
    <MainFooter />    
  </div>
</template>

<script lang="ts">
import MainNavbar from "../Layouts/MainNavbar.vue";
import MainBanner from "../HomeFive/MainBanner.vue";
import OurFeatures from "../HomeThree/OurFeatures.vue";
import HowWeWork from "../HomeTwo/HowWeWork.vue";
import BestServices from "../HomeFive/BestServices.vue";
import OurDepartment from "../HomeTwo/OurDepartment.vue";
import OurTestimonials from "../HomeFive/OurTestimonials.vue";
import BookAppointment from "../HomeFive/BookAppointment.vue";
import GalleryExhibition from "../HomeThree/GalleryExhibition.vue";
import MainFooter from "../Layouts/MainFooter.vue";


import { defineComponent } from "vue";

export default defineComponent({
  name: "HomeFivePage",
  components: {
    MainNavbar,
    MainBanner,
    OurFeatures,
    HowWeWork,
    BestServices,
    OurDepartment,
    OurTestimonials,
    BookAppointment,
    GalleryExhibition,
    MainFooter,
  },
  data() {
    return {
      isSticky: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      const scrollPos = window.scrollY;
      this.isSticky = scrollPos >= 100;
    });
  },
});
</script>